export const POD_REJECTION_REASONS = [
  {
    _id: "Vehicle Info Error: incorrect, missing or unclear vehicle number",
    name: "Vehicle Info Error: incorrect, missing or unclear vehicle number",
  },
  {
    _id: "Quantity mismatches (POD vs Bill of supply)",
    name: "Quantity mismatches (POD vs Bill of supply)",
  },
  {
    _id: "POD File error: missing pages",
    name: "POD File error: missing pages",
  },
  {
    _id: "POD File error: incorrect uploads",
    name: "POD File error: incorrect uploads",
  },
  {
    _id: "Missing POD Details: date not mentioned",
    name: "Missing POD Details: date not mentioned",
  },
  {
    _id: "Missing POD Details: missing signatures or stamps",
    name: "Missing POD Details: missing signatures or stamps",
  },
  {
    _id: "Others",
    name: "Others",
    helperText: "Reason missing? Select this option.",
  },
];

export const QC_REJECTION_REASONS = [
  {
    _id: "Quantity mismatches (QC vs Bill of supply)",
    name: "Quantity mismatches (QC vs Bill of supply)",
  },
  {
    _id: "QC File error: missing pages",
    name: "QC File error: missing pages",
  },
  {
    _id: "QC File error: incorrect uploads",
    name: "QC File error: incorrect uploads",
  },
  {
    _id: "Missing QC Details: date not mentioned",
    name: "Missing QC Details: date not mentioned",
  },
  {
    _id: "Missing QC Details: missing signatures or stamps",
    name: "Missing QC Details: missing signatures or stamps",
  },
  {
    _id: "Others",
    name: "Others",
    helperText: "Reason missing? Select this option.",
  },
];

export const STAGE_TO_CTA_PROPS_MAPPINGS = {
  "POD Received": {
    label: "Reject POD",
  },
  "QC Received": {
    label: "Reject QC",
  },
};

export const REJECT_POD_PROPS = {
  note: "NOTE: Invoice moves to POD rejected stage.\n POD and associated CN will get cancelled automatically!",
  form: {
    dropdown: {
      placeholder: "Select reason to reject POD",
      help: "Why do you want to reject the POD against this invoice? Please Select!",
    },
  },
};

export const REJECT_QC_PROPS = {
  note: "NOTE: Invoice moves to QC rejected stage.\n Quality Check Report, associated CN and  associated DN will get cancelled automatically!",
  form: {
    dropdown: {
      placeholder: "Select reason to reject quality check report",
      help: "Why do you want to reject the quality check report against this invoice? Please Select!",
    },
  },
};

export const CONFIRMATION_DIALOG_TEXT_MAPPING = {
  "POD Received": {
    ACCEPT: {
      title: `Accept proof of delivery`,
      submitLabel: "Accept POD",
      text: "Are you sure you want to accept this proof of delivery?",
    },
    REJECT: {
      text: "Are you sure you want to reject the POD",
    },
  },
  "QC Received": {
    ACCEPT: {
      title: `Accept Quality Check Report`,
      submitLabel: "Accept QC",
      text: "Are you sure you want to accept this Quality Check Report?",
    },
    REJECT: {
      text: "Are you sure you want to reject the Quality Check Report",
    },
  },
};
